import ScalarIconGithubLogo_vue_vue_type_script_setup_true_lang_default from "./ScalarIconGithubLogo.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconGithubLogo.vue
var ScalarIconGithubLogo_default = ScalarIconGithubLogo_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconGithubLogo_default as default };

//# sourceMappingURL=ScalarIconGithubLogo.js.map